<template>
  <page :title="$tc('selling.sales')">
    <div class="box">
      <sale-filter @filter="onFilter"></sale-filter>
      <hr />
      <b-table
        class="is-middle"
        :loading="sales.loading"
        :data="sales.data"
        :current-page="sales.current_page"
        :per-page="sales.per_page"
        :total="sales.total"
        @page-change="
          page => {
            sales.changePage(page);
          }
        "
        paginated
        backend-pagination
        pagination-position="bottom"
      >
        <template slot-scope="props">
          <b-table-column label="#" width="100" centered>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column label="Cover" width="80" centered>
            <img
              :src="
                props.row.model.cover_image_url
                  ? props.row.model.cover_image_url
                  : 'http://via.placeholder.com/23x32'
              "
              style="height: 32px;"
            />
          </b-table-column>

          <b-table-column label="Name">
            <div>
              {{ props.row.model.magazine ? props.row.model.magazine.name + " /" : "" }}
              {{ props.row.model.title ?  props.row.model.title : props.row.model.name }}
            </div>

            <small>
              <router-link :to="'/orders/' + props.row.order.id">
                #{{ props.row.order.id }}
              </router-link>
            </small>
          </b-table-column>

          <b-table-column label="Type" >
            {{  props.row.model.cover_image_url ? 'Дугаар' : props.row.model.title }}
          </b-table-column>

          <b-table-column label="Publisher">
            <div v-if="props.row.model.magazine">
              <div>{{ props.row.model.magazine.publisher.name }}</div>

              <router-link
                :to="'/publishers/' + props.row.model.magazine.publisher.id"
              >
                #{{ props.row.model.magazine.publisher.id }}
              </router-link>
            </div>

            <div v-else>
              {{ props.row.order.id }}
            </div>
          </b-table-column>

          <b-table-column label="W+ fee" centered>
            {{ wPlusFee(props.row) | money }}
          </b-table-column>

          <b-table-column label="Publisher income" centered>
            {{ props.row.order.total_price - wPlusFee(props.row) | money }}
          </b-table-column>

          <b-table-column label="Payable" centered>
            <b-icon
              icon="check"
              type="is-success"
              v-if="props.row.distributed"
            ></b-icon>

            <b-tooltip v-else label="Нийлүүлэгчийн орлого олгогдоогүй">
              <b-icon icon="transfer"></b-icon>
            </b-tooltip>
          </b-table-column>

          <b-table-column label="Date" centered>
            {{ props.row.order.created_at | dateTime}}
          </b-table-column>
        </template>

        <template slot="footer" v-if="sales.response">
          <th colspan="5" class="has-text-right has-text-weight-bold">
            Нийт:
          </th>

          <th class="has-text-centered has-text-weight-bold">
            {{ sales.response.data.total.fee_amount / 2 | money }}
          </th>

          <th class="has-text-centered has-text-weight-bold">
            {{ sales.response.data.total.fee_amount / 2 | money }}
          </th>

          <th colspan="2" class="has-text-weight-bold">
            {{ sales.response.data.total.fee_amount  | money }}
          </th>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import SaleFilter from "../../components/filters/sale/Index";

export default {
  components: {
    SaleFilter
  },

  data() {
    return {
      sales:  new window.PaginatedRemoteCollection("/admin/api/sales").load()
    };
  },

  methods: {
    onFilter(filter) {
      this.sales.with(filter).load();
    },

    wPlusFee(item) {
      if (item.model.magazine) {
        var perc = item.model.magazine.sharing_percentage.split('/')[1];

        return item.order.total_price * perc / 100
      }

      return item.order.total_price / 5;
    }
  }
};
</script>
